// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__38iQo","image":"Header_image__3ykap","name":"Header_name__11nkT","info":"Header_info__2SswJ","infoRow":"Header_infoRow__2tJJY"};